import { object, string as yupString } from 'yup'

export const schemaForInitialLogin = object({
  email: yupString()
    .email('Invalid email address')
    .required('Please enter the required field'),
})
